import type { FastifyInstance } from 'fastify'
import { weatherRoutes } from './weather.routes.js'

export default async function weatherModule(app: FastifyInstance) {
  await app.register(weatherRoutes)
}
